<template>
  <div class="shadow rounded-lg h-full w-full">
    new
  </div>
</template>

<script>
// import TodayStats from '../../components/dashboard/TodayStats'

export default {
  name: 'DashboardIndex',
  components: {
    // TodayStats
  }
}
</script>

<style scoped>

</style>
